import rtl from '@/styles/rtl.module.scss';

export const IconTrendUp = () => (
  <svg
    className={rtl.dirDependent}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 80 80"
    width="1em"
    height="1em"
    fill="none"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={5}
      d="M73.333 20v20m0-20h-20m20 0L50 43.333c-1.818 1.818-2.726 2.727-3.707 3.212a6.667 6.667 0 0 1-5.92 0c-.98-.485-1.889-1.394-3.706-3.212v0c-1.818-1.817-2.727-2.726-3.707-3.212a6.666 6.666 0 0 0-5.92 0c-.98.486-1.89 1.395-3.707 3.212L6.667 60"
    />
  </svg>
);
